import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { MdLocalOffer } from "react-icons/md";
import { useTheme } from "../../common/hooks/useTheme";

import { ProductHeader } from "../../common/components/productHeader/ProductHeader";
import PromoItem from "./components/PromoItem";
import styles from "./PromoScreen.module.scss";
import { ROUTES } from "../../common/utils/constants";
import { useSelector } from "react-redux";
import { selectActivePromos } from "../../store/slices/promoSlice";
import { EmptyState } from "../../common/components/emptyState/EmptyState";
import { MediaCard } from "../../common/components/mediaCard/MediaCard";
import { PromoInterface } from "../../common/types/types";
import { PageMeta } from "../../common/components/pageMeta/PageMeta";

const getFirstImage = (files: string[] | undefined) => {
  if (!files || !Array.isArray(files)) return "";

  // 1. Сначала постер
  const poster = files.find((path) => path.includes("poster_"));
  if (poster) return poster;

  // 2. Потом обычная картинка
  const image = files.find(
    (path) => !path.includes("video_") && !path.includes("poster_"),
  );
  if (image) return image;

  // 3. Первый файл
  return files[0] || "";
};
export default function PromoScreen() {
  const { theme } = useTheme();
  const navigate = useNavigate();
  const activePromos = useSelector(selectActivePromos);

  const promoList = useMemo(() => {
    return activePromos
      .filter((promo) => promo.isVisible)
      .sort((a, b) => {
        const orderA = a.sortOrder ?? 0;
        const orderB = b.sortOrder ?? 0;
        return orderA - orderB;
      });
  }, [activePromos]);

  const handlePromoPress = (promo: PromoInterface) => {
    navigate(`${ROUTES.PROMO_ITEM}/${promo.id}`, { state: { item: promo } });
  };

  return (
    <div
      className={styles.container}
      style={{ backgroundColor: theme.background }}
    >
      <PageMeta />
      <ProductHeader
        title="Акции и скидки"
        isFavorite={false}
        showFavorite={false}
        textColor={theme.text}
        borderColor={theme.border}
      />

      <div className={styles.content}>
        {promoList.length === 0 ? (
          <div className={styles.emptyWrapper}>
            <EmptyState
              icon={MdLocalOffer}
              title="Нет активных акций"
              description="Следите за обновлениями — скоро появятся новые предложения"
            />
          </div>
        ) : (
          <div className={styles.grid}>
            {promoList.map((promo) => (
              <div key={promo.id} className={styles.gridItem}>
                <MediaCard
                  imageUrl={getFirstImage(promo.files)}
                  title={promo.name}
                  description={promo.description}
                  to={`${ROUTES.PROMO_ITEM}/${promo.id}`}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
